import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-page__content">
        <div className="not-found-page__code">404</div>
        <h1 className="not-found-page__title">Page Not Found</h1>
        <p className="not-found-page__message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button variant="primary" size="lg">
            Go Home
          </Button>
        </Link>
      </div>

      <div className="not-found-page__decoration">
        <svg viewBox="0 0 200 200" fill="none">
          <defs>
            <linearGradient id="notFoundGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#818cf8', stopOpacity: 0.2 }} />
              <stop offset="100%" style={{ stopColor: '#f472b6', stopOpacity: 0.2 }} />
            </linearGradient>
          </defs>
          <circle cx="100" cy="100" r="80" stroke="url(#notFoundGrad)" strokeWidth="2" strokeDasharray="8 8" />
          <circle cx="100" cy="100" r="60" stroke="url(#notFoundGrad)" strokeWidth="2" strokeDasharray="4 4" />
          <circle cx="100" cy="100" r="40" stroke="url(#notFoundGrad)" strokeWidth="2" />
        </svg>
      </div>
    </div>
  );
}
